import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/check.svg';
import MerchantReinsurance from '~/components/molecules/Product/MerchantReinsurance.vue';
import ProductOffers from '~/components/molecules/Product/ProductOffers.vue';
import USE_MARKETPLACE from '~/const/marketplace';
import AVAILABLE_FOR_LGM from '~/const/product';
import { DELIVERY_FAQ, RETURN_FAQ } from '~/const/faq';
export default {
  name: 'Reinsurance',
  components: {
    MerchantReinsurance: MerchantReinsurance,
    ProductOffers: ProductOffers
  },
  props: {
    deliveryPayload: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    activeDeliveryPayload: function activeDeliveryPayload() {
      var openStores = ['fr-FR', 'fr-BE', 'nl-BE', 'fr-CH', 'de-CH', 'it-CH', 'de-DE', 'fr-LU', 'it-IT', 'es-ES', 'de-AT'];
      return openStores.includes(this.locale.iso);
    },
    merchantUrl: function merchantUrl() {
      return this.buildMerchantUrl(this.locale, this.product.offer.merchant.reference);
    },
    returnsUrl: function returnsUrl() {
      return RETURN_FAQ[this.locale.iso] && RETURN_FAQ[this.locale.iso].returnsUrl;
    },
    homeDeliveryText: function homeDeliveryText() {
      if (this.locale.country === 'AT') {
        return this.$t('homeDeliveryAT');
      }

      if (this.product.marketplace || this.locale.iso === 'en-GB') {
        return this.$t('homeDeliveryWithoutWithdrawal');
      }

      return this.$t('homeDelivery');
    },
    deliveryUrl: function deliveryUrl() {
      return DELIVERY_FAQ[this.locale.iso] && DELIVERY_FAQ[this.locale.iso].deliveryUrl;
    },
    isMarketplaceOpen: function isMarketplaceOpen() {
      return USE_MARKETPLACE(this);
    },
    isProductsAvailableLGM: function isProductsAvailableLGM() {
      return AVAILABLE_FOR_LGM.includes(this.product.reference);
    },
    isNotProductsAvailableLAD: function isNotProductsAvailableLAD() {
      return this.isProductsAvailableLGM && this.isFR;
    },
    isFR: function isFR() {
      return this.locale.market === 'FR';
    },
    tradReturn: function tradReturn() {
      // Needed for FR
      return this.isFR ? this.$t('return') : this.$t('returns').toLowerCase();
    }
  }),
  methods: {
    handleClickMerchant: function handleClickMerchant(event) {
      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_vendeur',
          event_label: this.product.offer.merchant.name
        }
      });
    },
    handleClickDelivery: function handleClickDelivery(event) {
      this.$root.$emit('generic-tracking', event, {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_FAQ_Livraison',
          event_label: 'Clic_FAQ_Livraison'
        }
      });
    },
    handleClickReturns: function handleClickReturns(event) {
      this.$root.$emit('generic-tracking', event, {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_FAQ_Retours',
          event_label: 'Clic_FAQ_Retours'
        }
      });
    }
  }
};